import React from 'react';
import { Alert } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
// Redux
import { useSelector } from 'react-redux';

const ProvisionalUserAlert = ({ description = '', title = '' }) => {
  // - Global State from Store.js form Values
  const { currentUser } = useSelector((state) => state.auth);
  const isUserAllowed = currentUser.isVerified;
  if (isUserAllowed) {
    // Si el usuario está permitido, no mostrar nada
    return null;
  }
  const alertVariants = {
    hidden: { x: 100, opacity: 0 }, // Aparece desde la derecha
    visible: { x: 0, opacity: 1 }, // Posición final (en pantalla)
    exit: { x: -100, opacity: 0 }, // Sale hacia la izquierda
  };
  return (
    <AnimatePresence>
      <motion.div key="custom-alert" initial="hidden" animate="visible" exit="exit" variants={alertVariants} transition={{ duration: 0.4 }}>
        <Alert className="mb-2" variant="info">
          {title && (
            <>
              <span role="img" aria-label="info">
                ✨
              </span>{' '}
              <strong>{title}</strong>
            </>
          )}
          {/* {description && description} */}
          <br />
          <span role="img" aria-label="info">
            ℹ️
          </span>{' '}
          Estos son datos de muestra para que puedas conocer cómo funciona nuestro sistema. Cuando seas usuario <strong>verificado</strong>, verás toda tu
          información real y completa en esta sección.
          <br />
          <NavLink to="/verificacion" className="btn btn-info mt-3">
            <span>Verificar cuenta</span>
          </NavLink>
        </Alert>
      </motion.div>
    </AnimatePresence>
  );
};

export default ProvisionalUserAlert;
